






















import { AdvancedSelect } from '@/app/components';
import { computed, defineComponent, PropType, Ref } from '@vue/composition-api';
import { ModelAlgorithmLibrary } from '../types/model-algorithm-library.type';

export default defineComponent({
    name: 'ModelAlgorithmSelector',
    model: { prop: 'algorithm', event: 'change' },
    props: {
        algorithm: { type: String },
        library: { type: Object as PropType<{ key: ModelAlgorithmLibrary; label: string } | undefined> },
        purpose: { type: Object as PropType<{ key: string; label: string } | undefined> },
        disabled: { type: Boolean, fefault: false },
    },
    components: { AdvancedSelect },
    setup(props, { emit }) {
        // Map algorithms → purposes
        const algorithmPurposeMap: Record<string, string> = {
            // mllib - Models
            'mllib:Decision Tree Classifier': 'classification',
            'mllib:Random Forest Classifier': 'classification',
            'mllib:SVM Classifier': 'classification',
            'mllib:Logistic Regression': 'classification',
            'mllib:Naive Bayes': 'classification',

            'mllib:Decision Tree Regressor': 'regression',
            'mllib:Random Forest Regressor': 'regression',
            'mllib:Linear Regressor': 'regression',

            'mllib:Kmeans': 'clustering',

            // mllib - Transformers
            'mllib:PCA': 'dimensionalityReduction',
            'mllib:OneHotEncoder': 'encoding',
            'mllib:String Indexer': 'encoding',
            'mllib:Standard Scaler': 'scaling',
            'mllib:MinMax Scaler': 'scaling',

            // sklearn - Models (Classification)
            'sklearn:Decision Tree Classifier': 'classification',
            'sklearn:Random Forest Classifier': 'classification',
            'sklearn:KNN Classifier': 'classification',
            'sklearn:Logistic Regression': 'classification',
            'sklearn:Support Vector Classifier': 'classification',
            'sklearn:Nu-Support Vector Classifier': 'classification',
            'sklearn:Linear Support Vector Classifier': 'classification',
            'sklearn:Gaussian Naive Bayes Classifier': 'classification',
            'sklearn:Multinomial Naive Bayes Classifier': 'classification',
            'sklearn:Complement Naive Bayes Classifier': 'classification',
            'sklearn:Bernoulli Naive Bayes Classifier': 'classification',
            'sklearn:Categorical Naive Bayes Classifier': 'classification',
            'sklearn:One Class Support Vector Classifier': 'classification',

            // sklearn - Models (Regression)
            'sklearn:Decision Tree Regressor': 'regression',
            'sklearn:Random Forest Regressor': 'regression',
            'sklearn:KNN Regressor': 'regression',
            'sklearn:Linear Regression': 'regression',
            'sklearn:Support Vector Regressor': 'regression',
            'sklearn:Nu-Support Vector Regressor': 'regression',
            'sklearn:Linear Support Vector Regressor': 'regression',

            // sklearn - Models (Clustering)
            'sklearn:Kmeans Clustering': 'clustering',

            // sklearn - Transformers (Encoding)
            'sklearn:OneHotEncoder': 'encoding',
            'sklearn:Label Encoder': 'encoding',
            'sklearn:Ordinal Encoder': 'encoding',

            // sklearn - Transformers (Scaling)
            'sklearn:Standard Scaler': 'scaling',
            'sklearn:MinMax Scaler': 'scaling',

            // sklearn - Transformers (Dimensionality Reduction)
            'sklearn:PCA': 'dimensionalityReduction',

            // sklearn - Models (Outlier Detection)
            'sklearn:Isolation Forest': 'outlierDetection',
            'sklearn:Local Outlier Factor': 'outlierDetection',

            // xgboost
            'xgboost:Xgboost Classifier': 'classification',
            'xgboost:Xgboost Regressor': 'regression',
        };
        const algorithms: Ref<string[]> = computed(() => {
            if (!props.library?.key || !props.purpose?.key) return [];

            return Object.entries(algorithmPurposeMap)
                .filter(([key, val]) => key.split(':')[0] === props.library?.key && val === props.purpose?.key)
                .map(([key]) => key.split(':')[1]);
        });

        const currentAlgorithm: Ref<string | undefined> = computed({
            get: () => {
                if (algorithms.value.length === 1) {
                    emit('change', algorithms.value[0]);
                    return algorithms.value[0];
                }
                return algorithms.value.find((a: string) => a === props.algorithm);
            },
            set: (newAlgorithm: string | undefined): void => {
                emit('change', newAlgorithm);
            },
        });
        const algorithmItems: Ref<{ label: string }[]> = computed(() =>
            algorithms.value.map((label: string) => {
                return { label };
            }),
        );

        return { algorithms, algorithmItems, currentAlgorithm };
    },
});
